import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { TabsComponent } from "./tabs/tabs.component";
import { SharedModule } from "../shared/shared.module";
import { OpengroundHeaderComponent } from "./openground-header/openground-header.component";
import { PortalRoutingModule } from "./portal-routing.module";
import { UnexpectedComponent } from "./unexpected/unexpected.component";
import { CloudsComponent } from "./clouds/clouds.component";
import { QuickLinksComponent } from "./quick-links/quick-links.component";
import { FeaturesComponent } from './features/features.component';
import { PortalComponent } from './portal/portal.component';
import { BannerModule } from '../shared/banner/banner.module';
import { ConcurrentAccessComponent } from './concurrent-access/concurrent-access.component';

@NgModule({
  declarations: [
    TabsComponent,
    OpengroundHeaderComponent,
    UnexpectedComponent,
    CloudsComponent,
    QuickLinksComponent,
    FeaturesComponent,
    PortalComponent,
    ConcurrentAccessComponent
  ],
  imports: [CommonModule, SharedModule, RouterModule, PortalRoutingModule, BannerModule],
  exports: [PortalComponent],
})
export class PortalModule {}
